import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import './BottomTabBar.css'

const tabs = [
  {
    id: 'home',
    label: 'Home',
    path: '/',
    matchPaths: ['/', '/browse'],
    icon: (active: boolean) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? '#0ea5e9' : '#64748b'}>
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
      </svg>
    ),
  },
  {
    id: 'camera',
    label: 'Camera',
    path: '/scan',
    matchPaths: ['/scan'],
    requiresAuth: true,
    icon: (active: boolean) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? '#0ea5e9' : '#64748b'}>
        <path d="M12 15.2A3.2 3.2 0 0 1 8.8 12 3.2 3.2 0 0 1 12 8.8 3.2 3.2 0 0 1 15.2 12 3.2 3.2 0 0 1 12 15.2M9 2L7.17 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-3.17L15 2H9m3 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5z" />
      </svg>
    ),
  },
  {
    id: 'map',
    label: 'Map',
    path: '/map',
    matchPaths: ['/map'],
    icon: (active: boolean) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? '#0ea5e9' : '#64748b'}>
        <path d="M15 3l-6 2.25L3 3v18l6-2.25L15 21l6-2.25V3L15 3zm0 15.4l-6-2.25V5.6l6 2.25v10.55z" />
      </svg>
    ),
  },
  {
    id: 'you',
    label: 'You',
    path: '/profile',
    matchPaths: ['/profile'],
    requiresAuth: true,
    icon: (active: boolean) => (
      <svg width="24" height="24" viewBox="0 0 24 24" fill={active ? '#0ea5e9' : '#64748b'}>
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
      </svg>
    ),
  },
]

export default function BottomTabBar() {
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = useAuthStore((s) => s.token)

  // Hide on 3D viewer (when ?shopid= is present on root)
  if (pathname === '/' && searchParams.get('shopid')) return null

  const handleTabPress = (tab: typeof tabs[0]) => {
    if (tab.requiresAuth && !token) {
      navigate('/login')
      return
    }
    navigate(tab.path)
  }

  return (
    <nav className="bottom-tab-bar">
      {tabs.map((tab) => {
        const active = tab.matchPaths.includes(pathname)
        return (
          <button
            key={tab.id}
            className={`tab-item${active ? ' tab-item--active' : ''}`}
            onClick={() => handleTabPress(tab)}
          >
            {tab.icon(active)}
            <span className="tab-label">{tab.label}</span>
          </button>
        )
      })}
    </nav>
  )
}
